export default __webpack_public_path__ + "static/media/defaultImg.1a8290c2.jpg";